import { NumberField } from './NumberField';

interface Props {
  prefectureName: string;
  regionMin: number;
  siteMin: number;
  onChangeRegionMin: (n: number) => void;
  onChangeSiteMin: (n: number) => void;
}

export function WageInputs({ prefectureName, regionMin, siteMin, onChangeRegionMin, onChangeSiteMin }: Props) {
  return (
    <div className="section">
      <h2>
        <span className="num">3</span>賃金条件（加点判定用）
      </h2>
      <p className="section-desc">
        所在地（{prefectureName}）の地域別最低賃金は自動セットされます。事業場内最低賃金を入力すると加点段階が判定されます。
      </p>
      <div className="form-row">
        <div className="label">
          地域別最低賃金
          <small>選択中の都道府県：{prefectureName}（必要に応じ手動上書き可）</small>
        </div>
        <div>
          <NumberField value={regionMin} step={1} onChange={onChangeRegionMin} />
          <span className="unit">円/時間</span>
        </div>
      </div>
      <div className="form-row">
        <div className="label">
          事業場内最低賃金<small>事業場内で最も低い賃金（時給換算）</small>
        </div>
        <div>
          <NumberField value={siteMin} step={1} onChange={onChangeSiteMin} />
          <span className="unit">円/時間</span>
        </div>
      </div>
    </div>
  );
}
